import React from "react";
import { useNavigate } from "react-router-dom";
import BottomNav from "../../components/layouts/BottomNav";
import { showSuccess } from "../../utils/toast";
import {
  FaBoxOpen, FaUserEdit, FaTags, FaPhoneAlt,
  FaSignOutAlt, FaTachometerAlt, FaChevronRight, FaArrowLeft,
  FaFileInvoice
} from "react-icons/fa";

// Colors
const ICON_COLOR = "#232323";
const ICON_BG = "#f1f1f1";
const LOGOUT_BG = "#fbe7e7";
const LOGOUT_CLR = "#ed3333";
import { API_BASE } from '../../utils/url';
const DEFAULT_AVATAR = "https://randomuser.me/api/portraits/men/32.jpg";

// Get user info from localStorage, fallback to dummy if missing
const localUser = JSON.parse(localStorage.getItem('user') || '{}');
const userData = {
  name: localUser?.name || "User",
  email: localUser?.email || "user@email.com",
  avatar: localUser?.profile_photo
    ? (localUser.profile_photo.startsWith("http")
      ? localUser.profile_photo
      : API_BASE + localUser.profile_photo.replace(/^\/+/, ''))
    : DEFAULT_AVATAR
};

const AccountPage = () => {
  const navigate = useNavigate();

  // List cards (define here so navigate is in scope)
  const cardList = [
    {
      label: "Manage Orders",
      sub: "See all Orders",
      icon: <FaBoxOpen size={20} color={ICON_COLOR} />,
      onClick: () => navigate("/manage-orders")
    },
    {
      label: "My Quotations",
      sub: "View your quotation requests",
      icon: <FaFileInvoice size={20} color={ICON_COLOR} />,
      onClick: () => navigate("/my-quotations")
    },
    {
      label: "Update Profile",
      sub: "Click here to update the profile",
      icon: <FaUserEdit size={20} color={ICON_COLOR} />,
      onClick: () => navigate("/profile")
    },
    {
      label: "Catalogue Page",
      sub: "See all the products",
      icon: <FaTags size={20} color={ICON_COLOR} />,
      onClick: () => navigate("/categories")
    },
    {
      label: "Contact Details",
      sub: "See the details",
      icon: <FaPhoneAlt size={20} color={ICON_COLOR} />,
      onClick: () => navigate("/contact-details")
    }
  ];

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    showSuccess("Logged out successfully!");
    navigate("/login");
  };

  return (
    <div style={{
      background: "#fafbfc",
      minHeight: "100vh",
      padding: "0",
      fontFamily: "Montserrat, Arial, sans-serif"
    }}>
      {/* Top Bar */}
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        padding: "32px 0 20px 0"
      }}>
        {/* Row: Back Button + Page Title */}
        <div style={{
          display: "flex", alignItems: "center", gap: 0,
          padding: "0 14px 10px 6px", marginBottom: 20
        }}>
          {/* Back Button */}
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              marginRight: 10,
              display: "flex",
              alignItems: "center",
              cursor: "pointer"
            }}
            aria-label="Back"
          >
            <svg width="25" height="25" viewBox="0 0 24 24" fill="none"
              stroke="#222" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <div style={{
            fontWeight: 700,
            fontSize: 21,
            color: "#232323",
            letterSpacing: "0.2px",
            marginTop: 2
          }}>
            My Account
          </div>
        </div>
        <img
          src={userData.avatar}
          alt={userData.name}
          style={{
            width: 62, height: 62, borderRadius: "50%",
            boxShadow: "0 2px 18px 0 rgba(0,0,0,0.09)",
            objectFit: "cover", marginBottom: 12
          }}
        />
        <div style={{ fontSize: 19, fontWeight: 700, color: "#222", marginBottom: 3 }}>
          {userData.name}
        </div>
        <div style={{ color: "#909090", fontSize: 15, fontWeight: 500, marginBottom: 2 }}>
          {userData.email}
        </div>
      </div>

      {/* List Cards */}
      <div style={{ padding: "0 13px" }}>
        {cardList.map((item) => (
          <div
            key={item.label}
            onClick={item.onClick}
            style={{
              background: "#fff",
              borderRadius: 13,
              boxShadow: "0 3px 16px 0 rgba(40,44,63,0.07)",
              display: "flex",
              alignItems: "center",
              padding: "18px 14px 16px 15px",
              marginBottom: 17,
              cursor: "pointer",
              transition: "box-shadow 0.17s",
              position: "relative"
            }}
          >
            <div style={{
              minWidth: 32, minHeight: 32, background: ICON_BG,
              borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center",
              marginRight: 13
            }}>{item.icon}</div>
            <div style={{ flex: 1 }}>
              <div style={{
                fontWeight: 600,
                color: "#191919",
                fontSize: 16,
                marginBottom: 2
              }}>{item.label}</div>
              <div style={{
                color: "#a0a0a0",
                fontSize: 13,
                fontWeight: 500
              }}>{item.sub}</div>
            </div>
            <FaChevronRight size={20} color="#a3a3a3" />
          </div>
        ))}

        {/* Logout Card (Red icon) */}
        <div
          onClick={handleLogout}
          style={{
            background: "#fff",
            borderRadius: 13,
            boxShadow: "0 3px 16px 0 rgba(40,44,63,0.07)",
            display: "flex",
            alignItems: "center",
            padding: "18px 14px 16px 15px",
            marginBottom: 17,
            cursor: "pointer",
            transition: "box-shadow 0.17s",
            position: "relative"
          }}
        >
          <div style={{
            minWidth: 32, minHeight: 32, background: LOGOUT_BG,
            borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center",
            marginRight: 13
          }}>
            <FaSignOutAlt size={20} color={LOGOUT_CLR} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{
              fontWeight: 600,
              color: LOGOUT_CLR,
              fontSize: 16,
              marginBottom: 2
            }}>Logout</div>
            <div style={{
              color: "#aaa",
              fontSize: 13,
              fontWeight: 500
            }}>In case you want to logout</div>
          </div>
        </div>
      </div>
      {/* Disclaimer Marquee */}
      <div className="marquee-wrapper">
        <div className="marquee-content">
          Disclaimer - Colour and quantity may vary &nbsp; • &nbsp; Disclaimer - Colour and quantity may vary &nbsp; • &nbsp; Disclaimer - Colour and quantity may vary &nbsp; • &nbsp; Disclaimer - Colour and quantity may vary &nbsp; • &nbsp; Disclaimer - Colour and quantity may vary
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default AccountPage;
